import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay/hooks"
import { graphql } from "relay-runtime"
import {
  useCapacityPlansQuery$data,
  useCapacityPlansQuery as useCapacityPlansQueryType,
} from "@/modules/productivity-cockpit/services/__generated__/useCapacityPlansQuery.graphql"

const capacityPlansQuery = graphql`
  query useCapacityPlansQuery($date: Date!) {
    capacityPlans(date: $date) {
      ...CapacityPlanFragment @relay(mask: false)
    }
  }
`

export const useCapacityPlansQuery = () => {
  return useQueryLoader<useCapacityPlansQueryType>(capacityPlansQuery)
}

export const usePreloadCapacityPlansQuery = (queryRef: PreloadedQuery<useCapacityPlansQueryType>) => {
  return usePreloadedQuery<useCapacityPlansQueryType>(capacityPlansQuery, queryRef)
}

export type CapacityPlans = useCapacityPlansQuery$data
export type CapacityPlan = useCapacityPlansQuery$data["capacityPlans"][number]
export type UseCapacityPlansQueryType = useCapacityPlansQueryType
